var _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflowAutomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#1f396c",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 7,
    height: 5,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9.5,
    width: 7,
    height: 5,
    rx: 1,
    fill: "#2f6fed",
    stroke: "#2f6fed"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 16,
    width: 7,
    height: 5,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.5H17.5V9.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5V18.5H10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowAutomation);
export default __webpack_public_path__ + "static/media/workflowAutomation.544b59495184bccdd664af4f7f9cd095.svg";
export { ForwardRef as ReactComponent };